import {AdjacentResult} from '../../../types/adjacent-result';
import ListAction from './list-action';
import TraceableError from '../../error/traceable-error';

/**
 * Base action for any adjacent-endpoints of the Lawyer API.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default abstract class AdjacentAction extends ListAction {
  update(settings: any): void {
    // Create parameters for the API request
    const parameters = this.createRequestParameters(settings);

    // Notify before-update listeners
    this.beforeUpdateEvent.dispatch(parameters);

    fetch(parameters.url, {
        'method': 'GET'
      }
    ).then(response => {
      return response.json();
    })
      .then(result => {
        this.initializeResult(result, settings);
      })
      .catch(error => {
        throw new TraceableError('Updating adjacent failed.', error);
      });
  }


  protected initializeResult(result: AdjacentResult, settings: any) {
    // Reset result container
    this.resultContainer.innerHTML = '';
    if (!result) {
      this.showNoResultContainer();
      return;
    }
    this.hideNoResultContainer();
  }
}
